/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React, { Component } from "react";
import ButtonWrapper from "dc-preview-utils/src/components/Button/ButtonWrapper";
import FitPageIcon from "dc-icons/consumption/s_fit_page_hud_18.svg";
import FitWidthIcon from "dc-icons/consumption/s_fit_width_hud_18.svg";
import ZoomUICss from "./ZoomUI.css";
import { apiFactory } from "../../api/external/ApiFactory";
import { apiNames } from "../../constants/apiNames";
import { pageViewModifiers } from "constants/enums";
import * as constants from "constants/constants";

class PageViewModifierUI extends Component {
  componentDidMount() {
    apiFactory.registerApi(apiNames.MODE_CHANGE, () => ({
      setFixedWidth: args => this.props.fixWidthHandler(args)
    }));
  }

  render() {
    const { showFitWidthMode, showFitPageMode, showFixedWidthMode } = this.props;

    let highlightFitWidthIcon = false,
      highlightFitPageIcon = false,
      highlightFixedWidthIcon = false;
    if (this.props.isFitWidthModeOn()) highlightFitWidthIcon = true;
    else if (this.props.getPageViewModifier === pageViewModifiers.FIT_PAGE) highlightFitPageIcon = true;
    else if (this.props.getPageViewModifier === pageViewModifiers.FIXED_WIDTH) highlightFixedWidthIcon = true;

    return (
      <div className={ZoomUICss.PageViewModifiers}>
        {showFitWidthMode ? (
          <ButtonWrapper
            ariaLabel="arialabel.fitWidth"
            icon={FitWidthIcon}
            clickHandler={this.props.fitWidthHandler}
            shouldDisable={!this.props.shouldStartRendering}
            isSelected={highlightFitWidthIcon}
            tooltipString="tooltip.fitWidth"
            tooltipPlacement={constants.TOOLTIP_TOP_PLACEMENT}
            tooltipDelay={constants.TOOLTIP_DELAY}
          />
        ) : null}
        {showFitPageMode ? (
          <ButtonWrapper
            ariaLabel="arialabel.fitPage"
            icon={FitPageIcon}
            clickHandler={this.props.fitOneFullPageHandler}
            shouldDisable={!this.props.shouldStartRendering}
            isSelected={highlightFitPageIcon}
            tooltipString="tooltip.fitPage"
            tooltipPlacement={constants.TOOLTIP_TOP_PLACEMENT}
            tooltipDelay={constants.TOOLTIP_DELAY}
          />
        ) : null}
        {showFixedWidthMode ? (
          <ButtonWrapper
            ariaLabel="arialabel.fixedWidth"
            icon={FitWidthIcon}
            clickHandler={this.props.fixWidthHandler}
            shouldDisable={!this.props.shouldStartRendering}
            isSelected={highlightFixedWidthIcon}
            tooltipString="tooltip.fixedWidth"
            tooltipPlacement={constants.TOOLTIP_TOP_PLACEMENT}
            tooltipDelay={constants.TOOLTIP_DELAY}
          />
        ) : null}
      </div>
    );
  }
}

export { PageViewModifierUI };
